import PropTypes from 'prop-types'

import AtomSpinner from '@s-ui/react-atom-spinner'

import {BASE_CLASS} from '../settings.js'
import {StepTags} from './StepTags.js'
import {StepTitle} from './StepTitle.js'

export function Step({children, isLoading}) {
  return (
    <div className={`${BASE_CLASS}-step`}>
      {isLoading ? (
        <div className={`${BASE_CLASS}-spinner`}>
          <AtomSpinner />
        </div>
      ) : (
        children
      )}
    </div>
  )
}

Step.displayName = 'StepperFlowStep'
Step.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool
}

Step.Tags = StepTags
Step.Title = StepTitle
